define([
    'i18next',
    'backbone.marionette',
    'backbone.stickit',
    'jquery',
    'bootstrap'
], function(
    i18n,
    Mn
    ){

    /**
     * イメージアップロード付のModal-Formのベースクラス
     *
     *  - Submit前のValidationErrorハンドリングも含めて実装している
     *  - 利用時には、 ModalBaseView を extend して利用してください
     *
     *  注) このViewは以下の条件を満たす Template の利用を前提としています
     *    - bootstrap の `.form-group` クラスを利用している
     *    - bootstrap の `.form-group` クラスと共に、 model の attribute名をクラスとして指定する
     *    - bootstrap の `.form-group` 要素配下に、 `.alert-message` クラスを持つ要素を配置する
     *
     * @type {*|Object|void}
     */
    var ModalBaseView = Mn.View.extend({
        uploaderSelector: null,
        imageSelector: null,
        /**
         * ModalViewの初期セットアップを行います
         *
         * ModalBaseView を extend した先で、 this.$el に対する
         * レンダリングが終わった後にこのメソッドを呼び出して下さい
         *
         *  - ImageUploader の初期化
         *  - 登録ボタン、キャンセルボタン、閉じるボタンのクリック時のアクション設定
         *  - input フォーム内で 'Enter' キー入力時のアクション設定
         */
        setupModal: function() {
            _.bindAll(this, '_setting', 'setErrors', 'clearErrors', 'resetModal');
            this.listenTo(this.model, 'validated:invalid', this.setErrors);

            this.$settingButton = this.$('button.setting');
            this.$settingButton.click(this._setting);
            this.$('button.cancel').click(this.hide);
            this.$('button.close').click(this.hide);

            var self = this;

            this.$('.modal').on('shown.bs.modal', function() {
                $(this).find('input[type=text]:first').focus();
            });

            this.$('.modal').on('hidden.bs.modal', function() {
                self.resetModal();
            });
        },

        _setting: function() {
            this.$settingButton.addClass('disabled');
            this.$settingButton.find('.fa').removeClass('hide');
            if (this.setting && typeof this.setting === 'function') {
                this.setting();
            }
        },

        resetModal: function() {
            this.clearErrors();
            if (this.resetModel && typeof this.resetModel === 'function') {
                this.resetModel();
            }
        },

        /**
         * model の invalid イベントをリスンして、
         * Modal View にエラー内容を表示します。
         *
         * @param model
         * @param errors
         */
        setErrors: function(model, errors) {
            this.clearErrors();
            var self = this;
            _.each(errors, function(message, field) {
                self.$('div.form-group.' + field).addClass('has-error');
                self.$('div.form-group.' + field + ' .alert-message').html(i18n.t(message));
            });
        },

        /**
         * Modal View に表示されているエラー内容を
         * 全てクリアします。
         */
        clearErrors: function() {
            this.$settingButton.removeClass('disabled');
            this.$settingButton.find('.fa').addClass('hide');
            this.$('div.form-group').removeClass('has-error');
            $.each(this.$('div.form-group .alert-message'), function(index, obj) {
                $(obj).html('');
            });
        }
    });

    return ModalBaseView;
});



// WEBPACK FOOTER //
// ./common/ui/view/modal/base.js